import { render, staticRenderFns } from "./PickupAddressTable.vue?vue&type=template&id=4a9c6d90&scoped=true"
import script from "./PickupAddressTable.vue?vue&type=script&lang=ts"
export * from "./PickupAddressTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c6d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9c6d90')) {
      api.createRecord('4a9c6d90', component.options)
    } else {
      api.reload('4a9c6d90', component.options)
    }
    module.hot.accept("./PickupAddressTable.vue?vue&type=template&id=4a9c6d90&scoped=true", function () {
      api.rerender('4a9c6d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pickup-address/PickupAddressTable.vue"
export default component.exports